import React, { useState } from 'react';
import { MasterProtocol, CNCGroup } from '../../types';
import SSOMAChecklistManager from './SSOMAChecklistManager';
import SSOMAEventManager from './SSOMAEventManager';

interface SSOMAManagerProps {
    checklists: MasterProtocol[];
    setChecklists: React.Dispatch<React.SetStateAction<MasterProtocol[]>>;
    events: CNCGroup[];
    setEvents: React.Dispatch<React.SetStateAction<CNCGroup[]>>;
}

const SSOMAManager: React.FC<SSOMAManagerProps> = ({ 
    checklists, 
    setChecklists, 
    events, 
    setEvents 
}) => {
    const [subTab, setSubTab] = useState<'checklists' | 'events'>('checklists');

    return (
        <div className="space-y-6">
            {/* Header and Sub Tabs Selector */}
            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 pb-4 border-b border-slate-100 dark:border-slate-800">
                <div>
                    <h2 className="text-xl font-black text-slate-800 dark:text-white flex items-center gap-2">
                        <svg className="size-[26px] text-teal-650 flex-shrink-0" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 4C7.58 4 4 7.58 4 12v2h16v-2c0-4.42-3.58-8-8-8z" />
                            <path d="M11 4.5h2v8h-2z" opacity="0.15" fill="black" />
                            <path d="M2 15c0-.55.45-1 1-1h18c.55 0 1 .45 1 1s-.45 1-1 1H3c-.55 0-1-.45-1-1z" />
                        </svg>
                        Maestros de SSOMA
                    </h2>
                    <p className="text-xs text-slate-550 mt-1">Gestión corporativa de listas de verificación de actividades y clasificación de incidentes / eventos no deseados.</p>
                </div>
                
                {/* Sub-tabs pills */}
                <div className="flex bg-slate-100 dark:bg-slate-900 p-1 rounded-xl border border-slate-200/50 dark:border-slate-800 self-start lg:self-auto">
                    <button
                        onClick={() => setSubTab('checklists')}
                        className={`flex items-center gap-2 px-4 py-2 rounded-lg text-xs font-bold transition-all ${
                            subTab === 'checklists'
                                ? 'bg-white dark:bg-slate-800 text-teal-650 dark:text-teal-400 shadow-sm'
                                : 'text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200'
                        }`}
                    >
                        <span className="material-symbols-outlined text-[16px]">assignment_turned_in</span>
                        Check List de Actividades
                    </button>
                    <button
                        onClick={() => setSubTab('events')}
                        className={`flex items-center gap-2 px-4 py-2 rounded-lg text-xs font-bold transition-all ${
                            subTab === 'events'
                                ? 'bg-white dark:bg-slate-800 text-red-500 dark:text-red-400 shadow-sm'
                                : 'text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200'
                        }`}
                    >
                        <span className="material-symbols-outlined text-[16px]">report_problem</span>
                        Eventos No Deseados
                    </button>
                </div>
            </div>

            {/* Active Content */}
            <div className="pt-2">
                {subTab === 'checklists' ? (
                    <SSOMAChecklistManager 
                        templates={checklists} 
                        setTemplates={setChecklists} 
                    />
                ) : (
                    <SSOMAEventManager 
                        groups={events} 
                        setGroups={setEvents} 
                    />
                )}
            </div>
        </div>
    );
};

export default SSOMAManager;
